import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { GraphQlLiteral } from "@contember/client";
import { addEntityAtIndex } from "./addEntityAtIndex.js";
import { EntitySubTree } from "../coreComponents/EntitySubTree.js";
import { SugaredField } from "../helperComponents/SugaredField.js";
import { EntityListSubTree } from "../coreComponents/EntityListSubTree.js";
import { Component } from "../coreComponents/Component.js";
import { QueryLanguage } from "../queryLanguage/QueryLanguage.js";
import { Field } from "../coreComponents/Field.js";
const SetOrderFieldOnCreate = Component(
  () => null,
  ({ orderField, newOrderFieldValue, entity }, environment) => {
    const desugaredOrderField = QueryLanguage.desugarRelativeSingleField(orderField, environment);
    const getOrderBy = (order) => [
      desugaredOrderField.hasOneRelationPath.map((relation) => relation.field).reduceRight(
        (accumulator, currentValue) => ({
          [currentValue]: accumulator
        }),
        {
          [desugaredOrderField.field]: new GraphQlLiteral(order)
        }
      )
    ];
    if (newOrderFieldValue === void 0) {
      const qel = {
        entities: entity,
        expectedMutation: "none",
        limit: 1,
        orderBy: getOrderBy("desc")
      };
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          EntitySubTree,
          {
            entity,
            isCreating: true,
            onBeforePersist: (getAccessor, bindingOperations) => {
              const listSubTree = bindingOperations.getEntityListSubTree(qel);
              const entities = Array.from(listSubTree);
              const newOrderFieldValue2 = !entities.length ? 0 : (entities[0].getRelativeSingleField(desugaredOrderField).value ?? 0) + 1;
              getAccessor().getRelativeSingleField(desugaredOrderField).updateValue(newOrderFieldValue2);
            },
            children: /* @__PURE__ */ jsx(SugaredField, { field: orderField })
          }
        ),
        /* @__PURE__ */ jsx(EntityListSubTree, { ...qel, children: /* @__PURE__ */ jsx(SugaredField, { field: orderField }) })
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Field, { field: desugaredOrderField, defaultValue: newOrderFieldValue, isNonbearing: true }),
      /* @__PURE__ */ jsx(
        EntityListSubTree,
        {
          entities: entity,
          expectedMutation: "anyMutation",
          orderBy: getOrderBy("asc"),
          onBeforePersist: (getAccessor, bindingOperations) => {
            let newEntityKey = void 0;
            addEntityAtIndex(getAccessor(), desugaredOrderField, newOrderFieldValue, (getNewEntity) => {
              newEntityKey = getNewEntity().key;
            });
            newEntityKey && bindingOperations.getEntityByKey(newEntityKey).deleteEntity();
          },
          children: /* @__PURE__ */ jsx(SugaredField, { field: orderField })
        }
      )
    ] });
  },
  "SetOrderFieldOnCreate"
);
export {
  SetOrderFieldOnCreate
};
//# sourceMappingURL=SetOrderFieldOnCreate.js.map
